import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

function SingleLink({ text }) {
  const location = useLocation();
  const [isHomepage, setIsHomepage] = useState(location.pathname === "/");
  useEffect(() => {
    setIsHomepage(location.pathname === "/");
  }, [location.pathname]);
  return (
    <NavLink
      to={`/${text.toLowerCase().split(" ").join("-")}`}
      className={({ isActive }) =>
        `${isActive && "border-b-4 border-pink-500"} ${
          isHomepage && text === "Overview" && "border-b-4 border-pink-500"
        } min-w-fit`
      }
    >
      <button className="min-w-fit font-semibold px-3 py-3">{text}</button>
    </NavLink>
  );
}

const SubHeader = () => {
  return (
    <div className="flex justify-between overflow-x-auto space-x-3 px-3 text-sm sm:text-lg">
      <SingleLink text="Overview" />
      <SingleLink text="Salary Details" />
      <SingleLink text="Employment Contract" />
      <SingleLink text="Insurance" />
      <SingleLink text="Benifits" />
      <SingleLink text="Payslips" />
    </div>
  );
};

export default SubHeader;
